export default __webpack_public_path__ + "static/media/ic-transactions.13066f2e.svg";